<template>
  <SettingsPageLayout>
    <DetailForm
      title="Website"
      description="Use the following code snippet to add a widget of your Humaniz.io jobs to your own company website. This allows potential candidates to apply for your Humaniz.io jobs directly from your website. Take full advantage of your organic website traffic."
      action="Save"
      hideaction="true"
      hidecancel="true"
      v-if="loaded"
    >
      <TextAreaInput label="Code Snippet" :modelValue="websiteLink" @update:modelValue="websiteLink = $event" />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      websiteLink: '',
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/1`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.websiteLink = `<iframe src="https://www.humaniz.io/widget?company=${data.record.id}" width="100%" height="400" />`;
          self.loaded = true;
        });
    },
  },
};
</script>
